__turbopack_context__.v({
  "group": "Ph227W_group",
  "itemsList": "Ph227W_itemsList",
});
